'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["active", "role", "tabIndex", "children"];
import React, { useContext } from 'react';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { cssColorValue, semanticColors } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
var NavPillPanelContainer = styled.div.withConfig({
  displayName: "NavPillPanel__NavPillPanelContainer",
  componentId: "sc-3yvzv-0"
})(["", ";"], function (props) {
  return css(["color:", ";&:focus{", "}"], cssColorValue(semanticColors.textBase), !props.isUsingKeyboard ? 'outline: none;' : null);
});

/**
 * @deprecated
 * This component will be archived soon.
 * Use the TabsPanel component with instead.
 */
export var NavPillPanel = /*#__PURE__*/React.forwardRef(function NavPillPanel(_ref, ref) {
  var active = _ref.active,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'tabpanel' : _ref$role,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  return /*#__PURE__*/React.createElement(NavPillPanelContainer, Object.assign({
    ref: ref,
    role: role,
    hidden: active,
    tabIndex: tabIndex,
    isUsingKeyboard: isUsingKeyboard
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.NavPillPanel
  }), children);
});